export const Checkbox = ({className="", checked, onNewValue, children, ...props}) => {
    // make checkbox click in enter (by default only changes with space and that is taken for audio play/stop)
    function handleKeyDown (e) {
        if (e.key !== "Enter") return;
        onNewValue(!checked);
    }
    return ( 
        <label className={`${className} checkbox ${checked ? "active" : ""}`} {...props}>
            <input
                type="checkbox"
                checked={checked}
                onChange={e => onNewValue(e.target.checked, e)}
                onKeyDown={handleKeyDown}
            />
            <span>{children}</span> 
        </label>
    );
}